import { useMemo } from 'react';
import { useAsyncServiceEngineContext } from '../context/AsyncServicesEngineContext';

/**
 * Restituisce le opzioni per la selezione di un servizio asincrono.
 */
export function useAsyncServicesOptions() {
  const asyncContext = useAsyncServiceEngineContext();
  //  rimosso dal nome (${service.method} ${service.url})
  const options = useMemo(
    () =>
      asyncContext.services.map(service => ({
        value: service.id,
        label: `${service.name}`,
        service,
      })),
    [asyncContext.services],
  );

  return options;
}
